export default  [
    
    {
      id: -1,
      nombre: "Error Desconocido",
      descripcion: "Error Desconocido"
    },
    {
      id: 0,
      nombre: "OK",
      descripcion: "La consulta http tuvo respuesta satisfactoria."
    },
    {
      id: 1,
      nombre: "Error de Configuración",
      descripcion: "Error en la Configuración del Monitoreo"
    },
    {
      id: 2,
      nombre: "Error fatal en el monitoreo.",
      descripcion: "FATAL"
    },
    {
      id: 3,
      nombre: "Timeout",
      descripcion: "Tiempo de espera agotado o timeout"
    },
    {
      id: 4,
      nombre: "No se resolvió URL",
      descripcion: "No se conoce dirección IP del host"
    },
    {
      id: 5,
      nombre: "Periodo sin monitoreo",
      descripcion: "El objetivo no fue monitoreado en ese período"
    },
    {
      id: 6,
      nombre: "Timeout de la Página",
      descripcion: "Timeout en la Descarga Completa de la Página"
    },
    {
      id: 7,
      nombre: "Timeout",
      descripcion: "Timeout intentando en modo persistente infinito"
    },
    {
      id: 8,
      nombre: "OK",
      descripcion: "OK al segundo intento"
    },
    {
      id: 9,
      nombre: "DNS OK No autoritativo",
      descripcion: "La respuesta del DNS no es autoritativa, es decir, la respuesta proviene de tablas temporales (cache) de un DNS no oficial del dominio."
    },
    {
      id: 10,
      nombre: "Sin dominio",
      descripcion: "Dominio consultado no existe"
    },
    {
      id: 11,
      nombre: "Sin nombre",
      descripcion: "Nombre consultado no existe"
    },
    {
      id: 12,
      nombre: "Sin servidor",
      descripcion: "DNS consultado no existe"
    },
    {
      id: 13,
      nombre: "Error de contenido",
      descripcion: "El contenido de la página que se revisa no coincide con el patron. Esto significa que se obtiene elemento en el aplicativo pero con un contenido distinto al esperado."
    },
    {
      id: 14,
      nombre: "DNS OK autoritativo",
      descripcion: "DNS Ok Autoritativo"
    },
    {
      id: 15,
      nombre: "Sin respuesta",
      descripcion: "Servidor no responde"
    },
    {
      id: 16,
      nombre: "Sin respuesta",
      descripcion: "Servidor no responde"
    },
    {
      id: 17,
      nombre: "Servidor Correo OK",
      descripcion: "Fue posible obtener conexión con el servidor de correo."
    },
    {
      id: 18,
      nombre: "Error Autenticación",
      descripcion: "Problema de Autenticación"
    },
    {
      id: 19,
      nombre: "Error SMTP inseguro",
      descripcion: "Relay abierto"
    },
    {
      id: 20,
      nombre: "Downtime Funcional",
      descripcion: "Downtime Funcional"
    },
    {
      id: 21,
      nombre: "TXT vacío",
      descripcion: "En consulta de DNS CHAOS, el campo TXT se encuentra vacio."
    },
    {
      id: 22,
      nombre: "Campo no disponible",
      descripcion: "Campo CHAOS no disponible para consulta en DNS."
    },
    {
      id: 23,
      nombre: "Patrón de error encontrado",
      descripcion: "Patrón de error conocido encontrado"
    },
    {
      id: 24,
      nombre: "Certificado inválido",
      descripcion: "Certificado SSL Inválido"
    },
    {
      id: 25,
      nombre: "Faltaron Elementos",
      descripcion: "Faltaron Elementos por Descargar"
    },
    {
      id: 26,
      nombre: "Terminado con errores",
      descripcion: "Existieron errores en el monitoreo, pero pueden no ser de importancia"
    },
    {
      id: 27,
      nombre: "Timeout Javascript",
      descripcion: "Tiempo de espera agotado en paso Javascript"
    },
    {
      id: 28,
      nombre: "Error previo",
      descripcion: "Paso no ejecutado por error anterior"
    },
    {
      id: 29,
      nombre: "Error USSD",
      descripcion: "El paso devolvió un error USSD desde el operador"
    },
    {
      id: 30,
      nombre: "Mail OK",
      descripcion: "Mail Recibido OK"
    },
    {
      id: 31,
      nombre: "Error correo",
      descripcion: "Error en envio de correo"
    },
    {
      id: 32,
      nombre: "Error Conex. MailBox",
      descripcion: "Error Conex. MailBox"
    },
    {
      id: 33,
      nombre: "Timeout",
      descripcion: "Timeout en recepción de correo"
    },
    {
      id: 34,
      nombre: "Error en la recepción del correo",
      descripcion: "Error en la recepción del correo por parte del servidor"
    },
    {
      id: 35,
      nombre: "Error de contenido DNS",
      descripcion: "El contenido de la respuesta del DNS no coincide con el patron"
    },
    {
      id: 36,
      nombre: "Error conocido encontrado en DNS",
      descripcion: "El contenido de la respuesta del DNS corresponde a un error conocido"
    },
    {
      id: 40,
      nombre: "Error SOAP",
      descripcion: "Error SOAP en el servidor"
    },
    {
      id: 60,
      nombre: "Error dos patrones",
      descripcion: "No se encontró ninguno de los dos patrones buscados"
    },
    {
      id: 62,
      nombre: "Error primer patrón",
      descripcion: "No se encontró el primer patrón buscado"
    },
    {
      id: 64,
      nombre: "Error segundo patrón",
      descripcion: "No se encontró el segundo patrón buscado"
    },
    {
      id: 66,
      nombre: "Error SIF",
      descripcion: "No se encontró el patrón SIF"
    },
    {
      id: 67,
      nombre: "Error B2B",
      descripcion: "No se encontró el patrón B2B"
    },
    {
      id: 68,
      nombre: "Error B2B-SIF",
      descripcion: "No se encontró el patrón B2B-SIF"
    },
    {
      id: 69,
      nombre: "Error SAB",
      descripcion: "No se encontró el patrón SAB"
    },
    {
      id: 70,
      nombre: "Error SAB-SIF",
      descripcion: "No se encontró el patrón SAB-SIF"
    },
    {
      id: 71,
      nombre: "Error SAB-B2B",
      descripcion: "No se encontró el patrón SAB-B2B"
    },
    {
      id: 72,
      nombre: "Error SAB-B2B-SIF",
      descripcion: "No se encontró el patrón SAB-B2B-SIF"
    },
    {
      id: 73,
      nombre: "Error SRX",
      descripcion: "No se encontró el patrón SRX"
    },
    {
      id: 74,
      nombre: "Error SRX-SIF",
      descripcion: "No se encontró el patrón SRX-SIF"
    },
    {
      id: 75,
      nombre: "Error SRX-B2B",
      descripcion: "No se encontró el patrón SRX-B2B"
    },
    {
      id: 76,
      nombre: "Error SRX-B2B-SIF",
      descripcion: "No se encontró el patrón SRX-B2B-SIF"
    },
    {
      id: 77,
      nombre: "Error SRX-SAB",
      descripcion: "No se encontró el patrón SRX-SAB"
    },
    {
      id: 78,
      nombre: "Error SRX-SAB-SIF",
      descripcion: "No se encontró el patrón SRX-SAB-SIF"
    },
    {
      id: 79,
      nombre: "Error SRX-SAB-B2B",
      descripcion: "No se encontró el patrón SRX-SAB-B2B"
    },
    {
      id: 80,
      nombre: "Error SRX-SAB-B2B-SIF",
      descripcion: "No se encontró el patrón SRX-SAB-B2B-SIF"
    },
    {
      id: 81,
      nombre: "Error TOM",
      descripcion: "No se encontró el patrón TOM"
    },
    {
      id: 82,
      nombre: "Error TOM-SIF",
      descripcion: "No se encontró el patrón TOM-SIF"
    },
    {
      id: 83,
      nombre: "Error TOM-B2B",
      descripcion: "No se encontró el patrón TOM-B2B"
    },
    {
      id: 84,
      nombre: "Error TOM-B2B-SIF",
      descripcion: "No se encontró el patrón TOM-B2B-SIF"
    },
    {
      id: 85,
      nombre: "Error TOM-SAB",
      descripcion: "No se encontró el patrón TOM-SAB"
    },
    {
      id: 86,
      nombre: "Error TOM-SAB-SIF",
      descripcion: "No se encontró el patrón TOM-SAB-SIF"
    },
    {
      id: 87,
      nombre: "Error TOM-SAB-B2B",
      descripcion: "No se encontró el patrón TOM-SAB-B2B"
    },
    {
      id: 88,
      nombre: "Error TOM-SAB-B2B-SIF",
      descripcion: "No se encontró el patrón TOM-SAB-B2B-SIF"
    },
    {
      id: 89,
      nombre: "Error TOM-SRX",
      descripcion: "No se encontró el patrón TOM-SRX"
    },
    {
      id: 90,
      nombre: "Error TOM-SRX-SIF",
      descripcion: "No se encontró el patrón TOM-SRX-SIF"
    },
    {
      id: 91,
      nombre: "Error TOM-SRX-B2B",
      descripcion: "No se encontró el patrón TOM-SRX-B2B"
    },
    {
      id: 92,
      nombre: "Error TOM-SRX-B2B-SIF",
      descripcion: "No se encontró el patrón TOM-SRX-B2B-SIF"
    },
    {
      id: 93,
      nombre: "Error TOM-SRX-SAB",
      descripcion: "No se encontró el patrón TOM-SRX-SAB"
    },
    {
      id: 94,
      nombre: "Error TOM-SRX-SAB-SIF",
      descripcion: "No se encontró el patrón TOM-SRX-SAB-SIF"
    },
    {
      id: 95,
      nombre: "Error TOM-SRX-SAB-B2B",
      descripcion: "No se encontró el patrón TOM-SRX-SAB-B2B"
    },
    {
      id: 96,
      nombre: "Error TOM-SRX-SAB-B2B-SIF",
      descripcion: "No se encontró el patrón TOM-SRX-SAB-B2B-SIF"
    },
    {
      id: 200,
      nombre: "OK",
      descripcion: "OK"
    },
    {
      id: 204,
      nombre: "No Content",
      descripcion: "No Content"
    },
    {
      id: 301,
      nombre: "Redirección Permanente",
      descripcion: "Redirección Permanente"
    },
    {
      id: 302,
      nombre: "Redireccionado",
      descripcion: "Redireccionado"
    },
    {
      id: 304,
      nombre: "Not Modified",
      descripcion: "Not Modified"
    },
    {
      id: 307,
      nombre: "Movido Temporalmente",
      descripcion: "Movido Temporalmente"
    },
    {
      id: 400,
      nombre: "Error 400",
      descripcion: "Requerimiento sintácticamente incorrecto"
    },
    {
      id: 401,
      nombre: "Error 401",
      descripcion: "Acceso no autorizado"
    },
    {
      id: 403,
      nombre: "Error 403",
      descripcion: "Permiso denegado"
    },
    {
      id: 404,
      nombre: "Error 404",
      descripcion: "Página no encontrada"
    },
    {
      id: 405,
      nombre: "Error 405",
      descripcion: "Método de acceso no autorizado"
    },
    {
      id: 406,
      nombre: "Error 406",
      descripcion: "Página inaceptable"
    },
    {
      id: 407,
      nombre: "Error 407",
      descripcion: "Falló identificación en proxy"
    },
    {
      id: 408,
      nombre: "Error 408",
      descripcion: "Tiempo de espera agotado"
    },
    {
      id: 409,
      nombre: "Error 409",
      descripcion: "Conflicto en la solicitud"
    },
    {
      id: 410,
      nombre: "Error 410",
      descripcion: "Documento inaccesible"
    },
    {
      id: 411,
      nombre: "Error 411",
      descripcion: "Longitud requerida"
    },
    {
      id: 412,
      nombre: "Error 412",
      descripcion: "Condición falsa"
    },
    {
      id: 413,
      nombre: "Error 413",
      descripcion: "Requerimiento muy grande"
    },
    {
      id: 414,
      nombre: "Error 414",
      descripcion: "URL muy larga"
    },
    {
      id: 415,
      nombre: "Error 415",
      descripcion: "Medio no soportado"
    },
    {
      id: 416,
      nombre: "Error 416",
      descripcion: "Rango no satisfecho"
    },
    {
      id: 417,
      nombre: "Error 417",
      descripcion: "'expect' no encontrado"
    },
    {
      id: 439,
      nombre: "Error 439",
      descripcion: "Error 439"
    },
    {
      id: 500,
      nombre: "Error 500",
      descripcion: "Falla interna del servidor"
    },
    {
      id: 501,
      nombre: "Error 501",
      descripcion: "No implementado"
    },
    {
      id: 502,
      nombre: "Error 502",
      descripcion: "Error de proxy"
    },
    {
      id: 503,
      nombre: "Error 503",
      descripcion: "Servicio no disponible"
    },
    {
      id: 504,
      nombre: "Error 504",
      descripcion: "Timeout de proxy"
    },
    {
      id: 505,
      nombre: "Error 505",
      descripcion: "No soportado"
    },
    {
      id: 520,
      nombre: "Error 520",
      descripcion: "Falla interna del servidor"
    },
    {
      id: 521,
      nombre: "Error 521",
      descripcion: "Falla interna del servidor"
    },
    {
      id: 522,
      nombre: "Error 522",
      descripcion: "Falla interna del servidor"
    },
    {
      id: 600,
      nombre: "Error desconocido IVR",
      descripcion: "Error desconocido IVR"
    },
    {
      id: 601,
      nombre: "Troncal congestionado",
      descripcion: "Servidor de telefonia caido (congestion)."
    },
    {
      id: 602,
      nombre: "Operador contestó",
      descripcion: "EL operador atendió la llamada"
    },
    {
      id: 603,
      nombre: "Troncal ocupado",
      descripcion: "Troncal ocupado"
    },
    {
      id: 604,
      nombre: "Llamada no contestada",
      descripcion: "No se pudo realizar el monitoreo ya que el troncal no contesto la llamada"
    },
    {
      id: 605,
      nombre: "Operador no contestó",
      descripcion: "EL operador no atendió la llamada"
    },
    {
      id: 607,
      nombre: "Timeout",
      descripcion: "Tiempo de espera de la llamada agotado o silencio del audio mayor al esperado"
    },
    {
      id: 610,
      nombre: "LLamada colgada",
      descripcion: "La llamada dura menos de lo presupuestado (corte previo)."
    },
    {
      id: 613,
      nombre: "Error de contenido",
      descripcion: "El contenido del audio capturado no coincide con el patrón."
    },
    {
      id: 723,
      nombre: "Error patrón imagen",
      descripcion: "No se encontro el patrón de imagen buscado"
    },
    {
      id: 724,
      nombre: "Error patrón imagen inverso",
      descripcion: "Se encontro un patrón de imagen no esperado o erroneo"
    },
    {
      id: 725,
      nombre: "Error patrón imagen OCR",
      descripcion: "No se encontro el patrón OCR dentro de imagen buscado"
    },
    {
      id: 730,
      nombre: "Error patrón token",
      descripcion: "Error en obtención de Token remoto (Correo u aplicación externa)"
    },
    {
      id: 999,
      nombre: "Sin respuesta desde ISP",
      descripcion: "Se intento realizar una medicion en ISP, pero no se obtuvo una respuesta. Se asume estado con error para efectos de alertas globales"
    },
    {
      id: 1000,
      nombre: "Elemento excluído",
      descripcion: "Elemento excluído"
    },
    {
      id: 1001,
      nombre: "Conexión Rechazada",
      descripcion: "Conexión Rechazada"
    },
    {
      id: 1002,
      nombre: "Servidor Cerró Conexión",
      descripcion: "Servidor Cerró Conexión"
    },
    {
      id: 1003,
      nombre: "Servidor no Encontrado",
      descripcion: "Servidor no Encontrado"
    },
    {
      id: 1004,
      nombre: "Timeout en Conexión",
      descripcion: "Timeout en Conexión"
    },
    {
      id: 1005,
      nombre: "Elemento del Servidor No Encontrado",
      descripcion: "A pesar que el servidor web indico que existía el elemento interno o externo, este no puedo ser encontrado"
    },
    {
      id: 1006,
      nombre: "Timeout de la Operación del Socket",
      descripcion: "Se intento recuperar un elemento interno o externo que indico el elemento principal, pero el primero no respondió y no se pudo concretar la operación del socket. (puede darse el caso que este haya respondido correctamente al inicio"
    },
    {
      id: 1007,
      nombre: "Petición Cancelada",
      descripcion: "Se intento recuperar un elemento interno o externo que indico el elemento principal. pero la petición a este fue rechazada (por lo general pasa por scripts alojados en servidores de terceros)"
    },
    {
      id: 1999,
      nombre: "Error de Red Desconocido",
      descripcion: "Error de Red Desconocido"
    },
    {
      id: 2000,
      nombre: "Sin Medicion",
      descripcion: "Sin Medicion. No se pudo obtener status del monitoreo"
    },
    {
      id: 3000,
      nombre: "marcado cliente",
      descripcion: "Periodo marcado por el cliente"
    },
    {
      id: 9999,
      nombre: "Error desconocido IVR",
      descripcion: "Error desconocido IVR"
    },
    {
      id: 999999,
      nombre: "Error desconocido en Script",
      descripcion: "Error desconocido en Script"
    }
   
]